var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('standard-layout',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('navigation-bar',{ref:"header"})]},proxy:true}])},[_c('router-view',{style:({ 'margin-top': _vm.headerHeight + 'px' })})],1)}
var staticRenderFns = []

export { render, staticRenderFns }